"use strict";
exports.__esModule = true;
exports.PlanSetupType = void 0;
var PlanSetupType;
(function (PlanSetupType) {
    PlanSetupType["plan401k"] = "401k";
    PlanSetupType["starter401k"] = "Starter 401k";
    PlanSetupType["solo401k"] = "Solo 401k";
    PlanSetupType["plan403b"] = "403b";
    PlanSetupType["planHSA"] = "HSA";
    PlanSetupType["plan529"] = "529";
    PlanSetupType["planCashBalance"] = "CashBalance";
    PlanSetupType["planMEP"] = "MEP";
    PlanSetupType["planPEP"] = "PEP";
    PlanSetupType["planESA"] = "ESA";
    PlanSetupType["payments"] = "Payments";
})(PlanSetupType = exports.PlanSetupType || (exports.PlanSetupType = {}));
